import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@mui/material';
import { IconSun, IconMoon } from '@tabler/icons-react';
import { SET_THEME } from 'store/actions';
export default function ThemeButton() {
  const dispatch = useDispatch();
  const current = useSelector((state) => state.customization.theme);
  const label = current === 'light' ? '切换深色外观' : '切换浅色外观';
  return (
    <Tooltip title={label}>
      <IconButton
        aria-label={label}
        onClick={() => {
          const theme = current === 'light' ? 'dark' : 'light';
          localStorage.setItem('theme', theme);
          dispatch({ type: SET_THEME, theme });
        }}
      >
        {current === 'light' ? <IconMoon size={20} /> : <IconSun size={20} />}
      </IconButton>
    </Tooltip>
  );
}
